<script setup>
import {ref, computed} from "vue";
import {Carousel, Slide} from "vue3-carousel";
import 'vue3-carousel/dist/carousel.css'
import ActionCategoryIcon from "@/components/actions/partials/ActionCategoryIcon.vue";
import useActionCategories from "@/composables/useActionCategories";
import FadeTransition from "@/components/transitions/FadeTransition.vue";

const carousel = ref(null);

const previous = () => {
  if (carousel.value) {
    carousel.value.prev()
  }
}

const next = () => {
  if (carousel.value) {
    carousel.value.next()
  }
}

const showPreviousButton = computed(() => {
  if (carousel.value) {
    if (carousel.value.data.currentSlide.value === carousel.value.data.minSlide.value) {
      return false
    }
  }

  return true
})

const showNextButton = computed(() => {
  if (carousel.value) {
    if (carousel.value.data.currentSlide.value === carousel.value.data.maxSlide.value) {
      return false
    }
  }
  return true
});

const {data: categoriesData, isFetching} = useActionCategories();
</script>

<template>
  <Carousel
    ref="carousel"
    :items-to-scroll="3"
    :items-to-show="3"
    :gap="18"
    :class="{'tw-pl-[88px]': showPreviousButton, 'tw-pr-[88px]': showNextButton}"
  >
    <Slide
      v-for="category in categoriesData"
      :key="category.category"
      class="tw-border-2 tw-border-grey-mid tw-rounded-xl tw-flex tw-flex-col tw-items-center tw-justify-center tw-pt-8 tw-pb-5"
    >
      <div
        class="tw-w-[42px] tw-h-[42px] tw-flex tw-justify-center tw-mb-6 tw-items-center tw-bg-grey-highlight tw-rounded-xl"
      >
        <ActionCategoryIcon :category="category.category" />
      </div>

      <div class="tw-uppercase tw-text-grey-dark tw-mb-4">
        {{ category.category }}
      </div>

      <FadeTransition>
        <div v-if="isFetching">
          <svg-vue
            icon="icons/loading"
            class="tw-w-6 tw-h-[52px] tw-text-blue"
          />
        </div>

        <div
          v-else
          class="tw-text-blue tw-font-bold tw-text-[40px] tw-leading-13 tw-cursor-pointer"
        >
          {{ category.actions_count }}
        </div>
      </FadeTransition>
    </Slide>

    <template #addons>
      <svg-vue
        v-if="showPreviousButton"
        icon="icons/rounded-arrow-left"
        class="tw-w-8 tw-h-8 tw-absolute tw-top-1/2 -tw-translate-y-1/2 tw-left-3 tw-cursor-pointer"
        @click="previous"
      />

      <svg-vue
        v-if="showNextButton"
        icon="icons/rounded-arrow-right"
        class="tw-w-8 tw-h-8 tw-absolute tw-top-1/2 -tw-translate-y-1/2 tw-right-3 tw-cursor-pointer"
        @click="next"
      />
    </template>
  </Carousel>
</template>
